"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlliedResearch = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const Size_1 = require("../../render/Size");
const Tags_1 = require("../../Tags");
const Resources_1 = require("../../../Resources");
class AlliedResearch extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.ALLIED_RESEARCH,
            tags: [Tags_1.Tags.EARTH, Tags_1.Tags.SCIENCE],
            metadata: {
                cardNumber: 'Y44',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.preludeBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.vSpace();
                        ce.action('Discard your hand for 1 M€ per card, then draw 4 cards.', (eb) => {
                            eb.minus().text('ALL').cards(1).startAction.megacredits(1).multiplier.nbsp(Size_1.Size.SMALL).cards(4).digit;
                        });
                        ce.vSpace(Size_1.Size.LARGE);
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        player.addResource(Resources_1.Resources.MEGACREDITS, player.cardsInHand.length);
        player.cardsInHand.forEach((card, index) => {
            player.cardsInHand.splice(index, 1);
            player.game.dealer.discard(card);
        });
        player.cardsInHand = [];
        player.drawCard(4);
        return undefined;
    }
}
exports.AlliedResearch = AlliedResearch;
//# sourceMappingURL=AlliedResearch.js.map